/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row5_LabelInputs */

const en_mk_cmp_row5_label = /** @type {(inputs: Mk_Cmp_Row5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company memory`)
};

const id_mk_cmp_row5_label = /** @type {(inputs: Mk_Cmp_Row5_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memori perusahaan`)
};

/**
* | output |
* | --- |
* | "Company memory" |
*
* @param {Mk_Cmp_Row5_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row5_label = /** @type {((inputs?: Mk_Cmp_Row5_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row5_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row5_label(inputs)
	return en_mk_cmp_row5_label(inputs)
});